import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@repo/ping-react-js";
import "./App.scss";
import Sidebar from "./components/Sidebar";
import UsagePage from "./pages/UsagePage";
import ApiKeysPage from "./pages/ApiKeysPage";
import CredentialsPage from "./pages/CredentialsPage";
import OrgSettingsPage from "./pages/org/OrgSettingsPage";
import GlobalSettingsPage from "./pages/org/GlobalSettingsPage";

const App = () => {
  return (
    <div className="app-layout">
      <Sidebar />
      <div className="app-main">
        <Routes>
          <Route path="/" element={<Navigate to="/usage" replace />} />
          <Route path="/usage" element={<UsagePage />} />
          <Route path="/api-keys" element={<ApiKeysPage />} />
          <Route path="/user/:userId/credentials" element={<CredentialsPage />} />
          <Route path="/org/ping-global" element={<GlobalSettingsPage />} />
          <Route path="/org/:shortName" element={<OrgSettingsPage />} />
        </Routes>
        <ShowLoggedInUser />
      </div>
    </div>
  );
};

const ShowLoggedInUser = () => {
  const { ssoUser } = useAuth();
  if (!ssoUser?.email) return null;
  return (
    <div className="app-footer">Logged in as {ssoUser.email}</div>
  );
};

export default App;